<template>
  <div class="grid-containerv" @mouseleave="hoverFn(prevHovered, true)">
    <div
      @mouseover="hoverFn(time)"
      @click="selectTime(time)"
      v-for="time in times.filter(data =>  data.wOrm === workOrMeet || data.wOrm === 'both')"
      :key="time.value"
      :class="{
        'grid-itemv': true,
        'is-beginning': time.isStart,
        'is-end': time.isEnd,
        'is-between': checkIfBetween(time),
      }"
    >
      {{ time.value }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeRangePicker",
  props: {
    value: {
      type: Object
    },
    workOrMeet: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      timeRange: {
        start: "",
        end: "",
      },
      times: [
        {
          value: "01:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "01:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "01:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "01:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "02:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "02:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "02:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "02:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "03:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "03:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "03:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "03:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "04:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "04:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "04:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "04:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "05:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "05:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "05:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "05:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "06:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "06:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "06:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "06:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "07:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "07:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "07:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "07:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "08:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "08:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "08:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "08:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "09:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "09:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "09:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "09:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "10:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "10:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "10:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "10:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "11:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "11:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "11:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "11:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "12:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'both'
        },
        {
          value: "12:15",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "12:30",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "12:45",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'meet'
        },
        {
          value: "13:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "14:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "15:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "16:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "17:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "18:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "19:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "20:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "21:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "22:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "23:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
        {
          value: "24:00",
          isStart: false,
          isEnd: false,
          isBetween: false,
          wOrm: 'work'
        },
      ],
      prevHovered: null,
      beginning: null,
      end: null,
    };
  },
  methods: {
    setTimeRange() {
      this.$emit("input", {
        start: this.beginning?.value,
        end: this.end?.value,
      });
    },

    hoverFn(hoveredItem, isLeaveEvent = false) {
      if (this.prevHovered) {
        this.prevHovered.isBetween = false;
        this.prevHovered.isStart =
          this.prevHovered.value === this.beginning?.value;
        this.prevHovered.isEnd = this.prevHovered.value === this.end?.value;
      }

      if (isLeaveEvent) {
        if (this.beginning && !this.end) {
          this.prevHovered = null;
          this.beginning = null;
          this.resetTimesByTime(null);
          return;
        }
        return;
      }

      this.prevHovered = hoveredItem;
      if (!this.beginning) hoveredItem.isStart = true;
      else if (!this.end) hoveredItem.isEnd = true;
    },

    selectTime(time) {
      if (!this.beginning) {
        this.beginning = time;
        time.isStart = true;
      } else if (!this.end) {
        this.end = time;
        time.isEnd = true;
        this.timeRange.start = this.beginning.value;
        this.timeRange.end = this.end.value;
        this.setTimeRange();
      } else if (this.beginning && this.end) {
        this.beginning = time;
        this.end = null;
        this.resetTimesByTime(time);
      }
    },

    resetTimesByTime(time) {
      this.times.forEach((timex) => {
        if (timex.value === time?.value) {
          timex.isStart = true;
        } else {
          timex.isStart = false;
          timex.isEnd = false;
          timex.isBetween = false;
        }
      });
    },

    checkIfBetween(time) {
      if (this.beginning) {
        if (this.end) {
          if (this.times.indexOf(this.beginning) < this.times.indexOf(this.end)){
            if (
              this.times.indexOf(time) > this.times.indexOf(this.beginning) &&
              this.times.indexOf(time) < this.times.indexOf(this.end)
            ) {
              time.isBetween = true;
              return true;
            }
          } else {
            if (
              this.times.indexOf(time) > this.times.indexOf(this.beginning) ||
              this.times.indexOf(time) < this.times.indexOf(this.end)
            ) {
              time.isBetween = true;
              return true;
            }
          }
        } else {
          if (this.times.indexOf(this.beginning) < this.times.indexOf(this.prevHovered)){
            if (
              this.times.indexOf(time) > this.times.indexOf(this.beginning) &&
              this.times.indexOf(time) < this.times.indexOf(this.prevHovered)
            ) {
              time.isBetween = true;
              return true;
            }
          } else {
            if (
              this.times.indexOf(time) > this.times.indexOf(this.beginning) ||
              this.times.indexOf(time) < this.times.indexOf(this.prevHovered)
            ) {
              time.isBetween = true;
              return true;
            }
          }
        }
      }
      return false;
    },
  },
  mounted() {
    if (this.value && this.value.start && this.value.end) {
      this.beginning = this.times.find(
        (time) => time.value === this.value.start,
      );
      this.beginning.isStart = true;
      this.end = this.times.find((time) => time.value === this.value.end);
      this.end.isEnd = true;
    }
  },
};
</script>

<style scoped>
.grid-containerv {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}

.grid-itemv {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  padding: 3px;
  font-size: 18px;
  font-family: Helvetica, Arial, sans-serif;
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
}

.is-beginning {
  background-color: #3c78ff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  color: white !important;
}

.is-end {
  background-color: #3c78ff;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: white !important;
}

.is-between {
  background-color: rgba(60, 120, 255, 0.45);
  color: white !important;
}
</style>
